<ifr-page-title pageTitle="'LEFT_PANEL_MONTHLY_CALENDAR' | translate " />
<div
  id="wid-plan-content-0"
>
  <monthly-calendar
    type="6040"
    api-url="'/WebPlanningAPI'"
    auth-token="authToken"
    locale="locale"
    user-id="userId"
    theme="theme"
    licenses="licenses"
    on-auth-error="onAuthError"
    simple-user-id="simpleUserId"
    personnelNumberEnabled="personnelNumberEnabled"
    selectedPerson="selectedPerson"
    onSelectedPersonChange="onSelectedPersonChange"
    selectedBalanceSet="selectedBalanceSet"
    onSelectedBalanceSetChange="onSelectedBalanceSetChange"
  ></monthly-calendar>
</div>
